import { actions } from "../actions/types";

const initialState = {
  user: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case actions.SET_CURRENTUSER:
      return {
        ...state,
        user: action.payload,
      };
    default:
      return state;
  }
}
